import apiService from "./ApiService"
import { createQS } from "./Utils"

class EmpresaService {
  async get(termo, pagina) {
    try {
      const qs = createQS({ termo, pagina })
      return await apiService.get('empresa?' + qs)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getById(id) {
    try {
      return await apiService.get('empresa/' + id)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async create(data) {
    try {
      return await apiService.post('empresa', data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async update(id, data) {
    try {
      return await apiService.put('empresa/' + id, data)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async delete(id) {
    try {
      return await apiService.delete('empresa/' + id)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getEquipe(id) {
    try {
      return await apiService.get(`empresa/${id}/equipe`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getResponsavelTecnico(id) {
    try {
      return await apiService.get(`empresa/${id}/responsavel_tecnico`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async createResponsavelTecnico(idEmpresa, data) {
    try {
      return await apiService.post(`empresa/${idEmpresa}/responsavel_tecnico`, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async deleteResponsavelTecnico(idEmpresa, id) {
    try {
      return await apiService.delete(`empresa/${idEmpresa}/responsavel_tecnico/${id}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getPreposto(id) {
    try {
      return await apiService.get(`empresa/${id}/preposto`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async createPreposto(idEmpresa, data) {
    try {
      return await apiService.post(`empresa/${idEmpresa}/preposto`, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async deletePreposto(idEmpresa, id) {
    try {
      return await apiService.delete(`empresa/${idEmpresa}/preposto/${id}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

}

const empresaService = new EmpresaService()
export default empresaService